/**
 * This file exposes frequently used unit conversion methods.
 *
 * These methods are auto-imported in components and pages and can be used
 * directly in templates, <script setup> or anywhere in the Options API without
 * having to manually import them.
 */

/**
 * Converts kilometers to miles.
 *
 * @param km The number of kilometers to convert.
 * @returns The number of miles.
 *
 * @example kmToMi(10) // 6.21371
 */
export function kmToMi(km: number | string) {
  return Number(km) * 0.621371
}

/**
 * Converts miles to kilometers.
 *
 * @param mi The number of miles to convert.
 * @returns The number of kilometers.
 *
 * @example miToKm(10) // 16.0934
 */
export function miToKm(mi: number | string) {
  return Number(mi) * 1.60934
}
